import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import {
	Box,
	HStack,
	Text,
	Button,
	Checkbox,
	Flex,
	Icon,
	Select,
} from '@chakra-ui/react'
import { InputText, Form, SelectField, RadioInput } from '../../components/form'
import { toast } from "react-toastify";
import { fetchWrapper } from '../../helpers';
import { FieldArray } from 'formik';
import { LuTrash2 } from 'react-icons/lu';

function Create({ meClose, loadList, isOpenEdit, rs }) {
	const [TypeList, SetTypeList] = useState([]);
	const [Volumn, SetVolumnList] = useState([]);
	const [Salescontract, setSaleContract] = useState([]);
	const [channelList, setChannelList] = useState([]);
	const [accountList, setAccountList] = useState([]);
	const [categories, setCategoryList] = useState([]);
	const [value, setValue] = useState([]);
	const [kamList, setKamList] = useState([]);
	const [kamId, setKamId] = useState('');
	const [kamInfo, setKamInfo] = useState({ kam_name: '', kam_email: '' });
	const [checkboxState, setCheckboxState] = useState({
		checkboxState: {
			sms: {
				primary: false,
				secondary: false,
				separatePrimary: false,
				separateSecondary: false
			},
			otherChannelId: true
		}
	}); // Track the state of each checkbox
	const [formData, setFormData] = useState({
		name: '',
		contact_no: '',
		business_name: '',
		// customer_type_id: '',
		volumn_id: '',
		server_ip: [''],
		account_id: '',
		credit_limit: '0',

		price_model_id: '0',
		category_id: '',
		sale_contract_id: '',
		auto_send: '',
		channel_config: [],
		domain_name: "",
		api_limit: null,
		flow_api_limit: null,
		incoming_identifier: ""

	});
	const FormSchema = Yup.object().shape({
		// Basic required fields
		name: Yup.string().required('Name is required'),
		api_limit: Yup.number().required('Allowed TPS is required'),
		flow_api_limit: Yup.number().nullable(),

		// Contact number validation (non-negative numbers only)
		contact_no: Yup.string()
			.required('Contact number is required')
			.matches(/^\d+$/, 'Only numbers are allowed')
			.test(
				'no-negative',
				'Negative numbers are not allowed',
				value => parseInt(value) >= 0
			),

		business_name: Yup.string().required('Business name is required'),
		incoming_identifier: Yup.string().required('Incomming Identifier is required'),
		domain_name: Yup.string().required('Sub Domain is required'),
		// customer_type_id: Yup.string().required('Business type is required'),
		volumn_id: Yup.string().required('Volume is required'),

		// Server IP validation (IPv4 format)
		server_ip: Yup.array()
			.of(
				Yup.string()
					.required('Server IP is required')
					.matches(
						/^((25[0-5]|2[0-4]\d|1\d{2}|\d{1,2})\.){3}(25[0-5]|2[0-4]\d|1\d{2}|\d{1,2})$/,
						'Invalid IP format. Use xxx.xxx.xxx.xxx'
					)
			)
			.min(1, 'At least one IP is required'),


		account_id: Yup.string().required('Account type is required'),
		category_id: Yup.string().required('Business Category is required'),
		sale_contract_id: Yup.string().required('Sale Contract is required'),


		// Credit limit validation (conditional + non-negative)
		credit_limit: Yup.string()
			.when('account_id', {
				is: '1', // When account_id is '1' (Prepaid)
				then: () => Yup.string()
					.test(
						'valid-if-entered',
						'Credit limit must be a non-negative number',
						value => !value || (value && /^\d+$/.test(value) && parseInt(value) >= 0)
					), // Optional but must be valid if entered
				otherwise: () => Yup.string()
					.required('Credit limit is required')
					.matches(/^\d+$/, 'Only numbers are allowed')
					.test(
						'no-negative',
						'Negative numbers are not allowed',
						value => parseInt(value) >= 0
					) // Required and must be valid
			}),

		// Auto send validation
		auto_send: Yup.string().required('Auto send selection is required'),

		// Channel config validation
		channel_config: Yup.array().of(
			Yup.object().shape({
				channel_id: Yup.string(),
				value: Yup.string(),
				key: Yup.boolean()
			})
		)
	});

	useEffect(() => {
		if (isOpenEdit && rs) {
			try {

				const channelConfigData = rs.config ? JSON.parse(rs.config).channel_config : [];


				const initialCheckboxState = {};


				channelConfigData.forEach(config => {

					initialCheckboxState[config.channel_id] = true;


					if (config.channel_id === 1 && config.type == 'otp_trans') {
						initialCheckboxState[`${config.channel_id}_sms_split`] = config.is_split || false;

					}

					if (config.channel_id === 1 && config.type == 'marketing') {

						initialCheckboxState[`${config.channel_id}_mk_sms_split`] = config.is_split || false;
					}


					if (config.channel_id === 7) {
						initialCheckboxState[`${config.channel_id}_secondary_sms_split`] = config.is_split || false;
					}
				});


				setCheckboxState(initialCheckboxState);


				if (channelList && channelList.length > 0) {

					const preparedChannelConfig = channelList.map(channel => {


						// Default empty config for this channel
						const config = {
							channel_id: channel.id,
							value: '',
							key: false
						};

						// Find if this channel exists in the loaded config
						let existingConfig = channelConfigData.find(c => c.channel_id === channel.id);



						if (existingConfig) {
							config.key = true;
							console.log(existingConfig?.type, "Type")
							// Handle Primary SMS (channel_id = 1)
							if (channel.id === 1) {
								//const existingConfigOtp = channelConfigData.find(c => c.channel_id === channel.id && c.type && c?.type === 'otp_trans');
								const existingConfigOtp =
									channelConfigData.find(c => c.channel_id === channel.id && c?.type === 'otp_trans')
									|| channelConfigData.find(c => c.channel_id === channel.id);

								if (existingConfigOtp?.is_split) {
									config.primary_local = existingConfigOtp.local || '';
									config.primary_international = existingConfigOtp.int || '';
								} else {
									config.primary = existingConfigOtp?.value || '';
								}
								const existingConfigMarketing = channelConfigData.find(c => c.channel_id === channel.id && c?.type === 'marketing');
								if (existingConfigMarketing?.is_split) {
									config.mk_primary_local = existingConfigMarketing.local || '';
									config.mk_primary_international = existingConfigMarketing.int || '';
								} else {
									config.mk_primary = existingConfigMarketing?.value || '';
								}
							}


							// Handle Secondary SMS (channel_id = 7)
							else if (channel.id === 7) {
								if (existingConfig.is_split) {
									config.secondary_local = existingConfig.local || '';
									config.secondary_international = existingConfig.int || '';
								} else {
									config.secondary = existingConfig.value || '';
								}
							}
							// Handle other channels
							else {
								config.value = existingConfig.value || '';
							}
						}

						return config;
					});



					// Set the form data with all fields
					setFormData({
						name: rs.name || '',
						contact_no: rs.contact_no || '',
						business_name: rs.business_name || '',
						// customer_type_id: rs.customer_type_id || '',
						volumn_id: rs.volumn_id || '',
						server_ip: rs.server_ip ? rs.server_ip.split(',').map(ip => ip.trim()) : [''],
						account_id: rs.account_id || '',
						credit_limit: rs.credit_limit || '0',
						price_model_id: rs.price_model_id || '0',
						category_id: rs.category_id || '',
						sale_contract_id: rs.sale_contract_id || '',
						auto_send: `${rs.auto_send}` || '',
						domain_name: rs.domain_name || '',
						channel_config: preparedChannelConfig,
						id: rs.id,
						api_limit: rs.api_limit || null,
						flow_api_limit: rs.flow_api_limit || null,
						incoming_identifier: rs.incoming_identifier
					});
				}

				// Set value for credit limit conditional display
				setValue(rs?.Account?.name !== "Prepaid" ? 0 : "1");
			} catch (error) {
				console.error("Error processing edit data:", error);
				toast.error("Error loading customer data");
			}
		}
	}, [isOpenEdit, rs, channelList]);

	useEffect(() => {
		LoadTypeList()
		LoadVolumnList()
		LoadAccountList()
		loadChannelList()
		loadCategoryList()
		SaleContract()
		loadKamList()
	}, []);

	// Prefill selected KAM when editing an existing customer
	useEffect(() => {
		if (isOpenEdit && rs?.kam_email && kamList.length > 0) {
			const matched = kamList.find(kam => kam.email === rs.kam_email);
			if (matched) {
				setKamId(matched.id);
			}
		}
	}, [isOpenEdit, rs, kamList]);

	// Keep kam_name / kam_email in sync with the selected KAM
	useEffect(() => {
		const selected = kamList.find(kam => String(kam.id) === String(kamId));
		setKamInfo({
			kam_name: selected?.name || '',
			kam_email: selected?.email || '',
		});
	}, [kamId, kamList]);




	const loadChannelList = async () => {
		const url = `${process.env.REACT_APP_API_URL}/channel/list-all`;
		const data = await fetchWrapper.get(url)

		setChannelList(data.data);

		if (!isOpenEdit) {
			// Only set default values if not in edit mode
			const channelConfigPre = data.data.map(item => ({
				channel_id: item.id,
				value: '',
				key: false
			}));

			setChannelList(data.data);
			setFormData(prevData => ({
				...prevData,
				channel_config: channelConfigPre,
			}));
		}
	}


	const SaleContract = async () => {
		const url = `${process.env.REACT_APP_API_URL}/sale_channel/list`;
		const data = await fetchWrapper.get(url)

		setSaleContract(data)
	}
	const loadCategoryList = async () => {
		const url = `${process.env.REACT_APP_API_URL}/category/list`;
		const data = await fetchWrapper.get(url)

		setCategoryList(data)
	}

	const LoadTypeList = async () => {
		const url = `${process.env.REACT_APP_API_URL}/customer-type/list`;
		const data = await fetchWrapper.get(url)

		SetTypeList(data)
	}

	const LoadVolumnList = async () => {
		const url = `${process.env.REACT_APP_API_URL}/volumn/list`;
		const data = await fetchWrapper.get(url)

		SetVolumnList(data)
	}

	const LoadAccountList = async () => {
		const url = `${process.env.REACT_APP_API_URL}/account/list`;
		const data = await fetchWrapper.get(url)

		setAccountList(data)
	}

	const loadKamList = async () => {
		try {
			const response = await fetch('https://hivebe.eoceantechnologies.com/api/kam/list?status_id=1', {
				headers: {
					'x-api-key': 'fdda765f-fc57-5604-a269-52a7df8164ec',
					'x-published': '1',
				},
			});
			const data = await response.json();
			setKamList(data?.rows || []);
		} catch (error) {
			console.error('Error loading KAM list:', error);
		}
	}

	const handleKamChange = (e) => {
		setKamId(e.target.value);
	}






	const handleChange = (e) => {
		setValue(e)
	}

	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {

		const updatedChannelConfig = [];


		channelList.forEach((channel, index) => {
			const channelId = channel?.id;
			const channelName = channel?.name?.toLowerCase();
			const isChannelSelected = checkboxState[channelId];

			if (isChannelSelected) {

				if (channelName === 'sms') {
					const primarySMSConfig = {
						channel_id: 1,
						key: true,
						value: '',
						is_primary: true,
						type: 'otp_trans'
					};

					const primarySMSConfigMarketing = {
						channel_id: 1,
						key: true,
						value: '',
						is_primary: true,
						type: 'marketing'
					};

					// Otp and transaction
					if (checkboxState[`${channelId}_sms_split`]) {

						primarySMSConfig.value = values.channel_config[index]?.primary_local || '';
						primarySMSConfig.local = values.channel_config[index]?.primary_local || '';
						primarySMSConfig.int = values.channel_config[index]?.primary_international || '';
						primarySMSConfig.is_split = true;
					} else {

						primarySMSConfig.value = values.channel_config[index]?.primary || '';
						primarySMSConfig.local = values.channel_config[index]?.primary || '';
						primarySMSConfig.int = values.channel_config[index]?.primary || '';
						primarySMSConfig.is_split = false;
					}

					// Marketing
					if (checkboxState[`${channelId}_mk_sms_split`]) {

						primarySMSConfigMarketing.value = values.channel_config[index]?.mk_primary_local || '';
						primarySMSConfigMarketing.local = values.channel_config[index]?.mk_primary_local || '';
						primarySMSConfigMarketing.int = values.channel_config[index]?.mk_primary_international || '';
						primarySMSConfigMarketing.is_split = true;
					} else {

						primarySMSConfigMarketing.value = values.channel_config[index]?.mk_primary || '';
						primarySMSConfigMarketing.local = values.channel_config[index]?.mk_primary || '';
						primarySMSConfigMarketing.int = values.channel_config[index]?.mk_primary || '';
						primarySMSConfigMarketing.is_split = false;
					}

					updatedChannelConfig.push(primarySMSConfig);
					updatedChannelConfig.push(primarySMSConfigMarketing);
				}

				else if (channel?.id === 7) {
					const secondarySMSConfig = {
						channel_id: 7,
						key: true,
						value: '',
						is_primary: false
					};

					if (checkboxState[`${channelId}_secondary_sms_split`]) {

						secondarySMSConfig.value = values.channel_config[index]?.secondary_local || '';
						secondarySMSConfig.local = values.channel_config[index]?.secondary_local || '';
						secondarySMSConfig.int = values.channel_config[index]?.secondary_international || '';
						secondarySMSConfig.is_split = true;
					} else {

						secondarySMSConfig.value = values.channel_config[index]?.secondary || '';
						secondarySMSConfig.local = values.channel_config[index]?.secondary || '';
						secondarySMSConfig.int = values.channel_config[index]?.secondary || '';
						secondarySMSConfig.is_split = false;
					}

					updatedChannelConfig.push(secondarySMSConfig);
				}

				else {
					updatedChannelConfig.push({
						channel_id: channelId,
						key: true,
						value: values.channel_config[index]?.value || ''
					});
				}
			}
		});

		// Prepare the final payload
		const finalPayload = {
			...values,
			server_ip: Array.isArray(values.server_ip) ? values.server_ip.join(',') : values.server_ip,
			config: { channel_config: updatedChannelConfig },
			action: isOpenEdit ? "update" : '',
			api_limit: values.api_limit || null,
			flow_api_limit: values.flow_api_limit || null,
			kam_name: kamInfo.kam_name,
			kam_email: kamInfo.kam_email,
		};


		// Call API to save data
		if (isOpenEdit) {

			const url = `${process.env.REACT_APP_API_URL}/customer/update`;
			const response = await fetchWrapper.post(url, finalPayload)

			if (response.success || response.status === 200) {
				meClose();
				loadList()
				toast.success("Record has been updated")
			} else {

				toast.error(response.message || `${response.status} is sent from server`)
			}

		} else {
			const url = `${process.env.REACT_APP_API_URL}/customer/create`;
			const response = await fetchWrapper.post(url, finalPayload)

			if (response.success) {
				meClose();
				loadList()
				toast.success("Record has been created")
			} else {
				toast.error(response.message)
			}
		}
	}




	const handleCheckChange = (channelId, type, isChecked) => {
		setCheckboxState((prevState) => ({
			...prevState,
			[channelId]: {
				...prevState[channelId],
				[type]: isChecked,
			},
		}));
	};

	const autoSendList = [
		{ id: '1', name: 'Yes' },
		{ id: '0', name: 'No' },
	]
	return (


		<Form
			enableReinitialize={true}
			validationSchema={FormSchema}
			initialValues={formData}
			onSubmit={onSubmit}
			className="customer_form"
		>
			<Box mb="10px">
				<InputText name="business_name" title="Business Name" placeholder="Please Enter Business Name" inputProps={{ isRequired: true }} />
			</Box>

			<Box display="flex" flexWrap="wrap" justifyContent="space-between">
				<Box w="50%">
					<InputText
						name="name"
						title="Contact Person Name"

						placeholder="Please Enter Customer Name Eg:Dilawar"
						inputProps={{
							onKeyDown: (e) => {
								if ((e.keyCode >= 48 && e.keyCode <= 57) ||
									(e.keyCode >= 96 && e.keyCode <= 105)) {
									e.preventDefault();
								}
							},
							isRequired: true
						}}
					/>
				</Box>
				<Box w="49%">
					<InputText name="contact_no" title="Contact No" placeholder="Please Enter Contact Number" inputProps={{ isRequired: true }} />
				</Box>
			</Box>
			<Box mb="10px">
				<Text mb="4px" fontSize="14px" fontWeight="500">KAM</Text>
				<Select placeholder="Select KAM" value={kamId} onChange={handleKamChange}>
					{kamList.map((kam) => (
						<option key={kam.id} value={kam.id}>{kam.name}</option>
					))}
				</Select>
			</Box>
			<Box >
				<InputText name="domain_name" title="Sub Domain" placeholder="Enter Subdomain" inputProps={{ isRequired: true }} />
			</Box>
			<Box >
				<InputText name="incoming_identifier" title="Incoming Identifier" placeholder="Incoming Identifier" inputProps={{ isRequired: true }} />
			</Box>







			<HStack w="100%" >
				<Box w="49%">
					<SelectField name="account_id" list={accountList} title="Account Type" onChange={(e) => handleChange(e)} isRequired />
				</Box>

				{value === '1' ? null : (

					<Box w="50%">
						<InputText name="credit_limit" title="Credit Limit" placeholder="Credit Limit" inputProps={{ isRequired: true }} />
					</Box>

				)}

			</HStack>

			<HStack w="100%" >
				<Box w="49%">
					{/* <SelectField name="customer_type_id" list={TypeList} title="Business Category" isRequired /> */}
					<SelectField name="category_id" list={categories} title="Business Category" isRequired />
				</Box>
				<Box w="49%">
					<SelectField name="volumn_id" list={Volumn} title="Expected Monthly Messages Volume" isRequired />
				</Box>

			</HStack>
			{/* <HStack w="100%" >
				<Box w="100%">
					<SelectField name="category_id" list={categories} title="Category" isRequired />
				</Box>

			</HStack> */}
			<HStack w="100%" >

				<Box w="49%">
					<SelectField name="sale_contract_id" list={Salescontract} title="Sale Contract" isRequired />
				</Box>
				<Box w="49%">
					<InputText name="api_limit" title="Allowed TPS" placeholder="Allowed TPS" inputProps={{ isRequired: true }} />
				</Box>

			</HStack>

			<HStack w="100%" >
				<Box w="49%">
					<InputText name="flow_api_limit" title="Flow TPS" placeholder="Flow TPS" />
				</Box>
			</HStack>


			{/* This is the updated Channel section UI */}
			<div>
				<Text fontWeight="bold" mb={2} size={"lg"}>Available Channel</Text>



				{channelList?.map((channel, index) => {
					const ChannelConfigList = { data: channel?.ChannelApiConfigs };
					const isSMS = channel.name?.toLowerCase() === 'sms';
					const isSMSSecondary = channel?.id === 7;

					const handleChannelCheckChange = (channelId, checked) => {
						setCheckboxState((prev) => {
							const newState = { ...prev, [channelId]: checked };

							if (!checked) {
								// Reset all SMS-specific nested states
								newState[`${channelId}_sms_split`] = false;
								newState[`${channelId}_mk_sms_split`] = false;
								newState[`${channelId}_secondary_sms_split`] = false;
							}

							return newState;
						});
					};

					return (
						<Box key={channel.id}>

							<Checkbox
								onChange={(e) => handleChannelCheckChange(channel.id, e.target.checked)}
								value={channel.id}
								isChecked={checkboxState[channel.id]}
								mb={2}
							>
								{channel.name}
							</Checkbox>

							{/* Primary SMS Configuration */}

							{checkboxState[channel.id] && isSMS && (
								<Box pl={4}>
									<Text fontWeight="bold" mb={2} size={"lg"}>OTP and Transaction</Text>


									<Checkbox
										onChange={(e) =>
											setCheckboxState((prev) => ({
												...prev,
												[`${channel.id}_sms_split`]: e.target.checked
											}))
										}
										isChecked={checkboxState[`${channel.id}_sms_split`] || false}
										mb={2}
									>
										Separate Local & International Accounts
									</Checkbox>

									{checkboxState[`${channel.id}_sms_split`] ? (
										<HStack spacing={4} align="start" mt={2}>
											<Box flex={1}>
												<SelectField
													name={`channel_config.${index}.primary_local`}
													list={ChannelConfigList}
													title="Primary - Local Account"
													isRequired={true}
												/>
											</Box>
											<Box flex={1}>
												<SelectField
													name={`channel_config.${index}.primary_international`}
													list={ChannelConfigList}
													title="Primary - International Account"
													isRequired={true}
												/>
											</Box>
										</HStack>
									) : (
										<SelectField
											name={`channel_config.${index}.primary`}
											list={ChannelConfigList}
											title="Primary Config"
											isRequired={true}
											mt={2}
										/>
									)}
								</Box>
							)}

							{checkboxState[channel.id] && isSMS && (
								<Box pl={4}>
									<Text fontWeight="bold" mb={2} size={"lg"}>Marketing</Text>

									<Checkbox
										onChange={(e) =>
											setCheckboxState((prev) => ({
												...prev,
												[`${channel.id}_mk_sms_split`]: e.target.checked
											}))
										}
										isChecked={checkboxState[`${channel.id}_mk_sms_split`] || false}
										mb={2}
									>
										Separate Local & International Accounts
									</Checkbox>

									{checkboxState[`${channel.id}_mk_sms_split`] ? (
										<HStack spacing={4} align="start" mt={2}>
											<Box flex={1}>
												<SelectField
													name={`channel_config.${index}.mk_primary_local`}
													list={ChannelConfigList}
													title="Primary - Local Account"
													isRequired={true}
												/>
											</Box>
											<Box flex={1}>
												<SelectField
													name={`channel_config.${index}.mk_primary_international`}
													list={ChannelConfigList}
													title="Primary - International Account"
													isRequired={true}
												/>
											</Box>
										</HStack>
									) : (
										<SelectField
											name={`channel_config.${index}.mk_primary`}
											list={ChannelConfigList}
											title="Primary Config"
											isRequired={true}
											mt={2}
										/>
									)}
								</Box>
							)}

							{/* Secondary SMS Configuration */}
							{checkboxState[channel.id] && isSMSSecondary && (
								<Box pl={4}>
									<Checkbox
										onChange={(e) =>
											setCheckboxState((prev) => ({
												...prev,
												[`${channel.id}_secondary_sms_split`]: e.target.checked
											}))
										}
										isChecked={checkboxState[`${channel.id}_secondary_sms_split`] || false}
										mb={2}
									>
										Separate Local & International Accounts
									</Checkbox>

									{checkboxState[`${channel.id}_secondary_sms_split`] ? (
										<HStack spacing={4} align="start" mt={2}>
											<Box flex={1}>
												<SelectField
													name={`channel_config.${index}.secondary_local`}
													list={ChannelConfigList}
													title="Secondary - Local Account"
													isRequired={true}
												/>
											</Box>
											<Box flex={1}>
												<SelectField
													name={`channel_config.${index}.secondary_international`}
													list={ChannelConfigList}
													title="Secondary - International Account"
													isRequired={true}
												/>
											</Box>
										</HStack>
									) : (
										<SelectField
											name={`channel_config.${index}.secondary`}
											list={ChannelConfigList}
											title="Secondary Config"
											isRequired={true}
											mt={2}
										/>
									)}
								</Box>
							)}

							{/* Non-SMS Channels */}
							{checkboxState[channel.id] && !isSMS && !isSMSSecondary && ChannelConfigList.data?.length > 0 && (
								<Box pl={4}>
									<SelectField
										name={`channel_config.${index}.value`}
										list={ChannelConfigList}
										title="Select Config"
										isRequired={true}
									/>
								</Box>
							)}
						</Box>
					);
				})}
			</div>


			{/* <Box mb="10px">
				<InputText name="server_ip" title="Server IP" placeholder="Please Enter 127.0.0.1" inputProps={{ isRequired: true }} />
			</Box> */}
			<Box mb="10px" className="server_ip">
				<Text fontWeight="bold" mb={2}>Whitelisted IP</Text>
				<FieldArray name="server_ip" >
					{({ push, remove, form }) => (
						<Box w={'100%'}>
							{form?.values?.server_ip?.map((ip, index) => (
								<HStack key={`server-ip-${index}`} mb={2}>

									<Flex alignItems={"center"} gap="10px" w="100%">
										<InputText
											name={`server_ip.${index}`}
											placeholder="Enter Server IP"
											inputProps={{ isRequired: true }}
											style={{ width: "100%" }}
										/>
										<Icon
											as={LuTrash2}
											size="sm"
											colorScheme="red"
											onClick={() => remove(index)}
											className={form.values.server_ip.length === 1 ? 'disable_icon' : ""}


										/>

									</Flex>
								</HStack>
							))}
							<Button size="sm" onClick={() => push('')} colorScheme="blue">
								+ Add IP Address
							</Button>
						</Box>
					)}
				</FieldArray>
			</Box>


			<Box mb="3px">
				<RadioInput name="auto_send" list={autoSendList} title="Fail Over Message" placeholder="Fail Over Message" />
			</Box>
			<Box mb="10px">
				<Text fontSize="12px" color="#ABABAB">This will send message using the alternate channels incase the message delivery fails with primary channel</Text>
			</Box>




			<Button py="10px" px="25px" color="#fff" bg="#2563eb" fontSize="14px" fontWeight="500" fontFamily="'Open Sans', sans-serif"
				mb={4}

				type='submit'
			>
				{isOpenEdit ? "Edit Customer" : "Add New Customer"}
			</Button>
		</Form>


	)
}

export default Create;